/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import AddressSelectionModal from './AddressSelectionModal/AddressSelectionModal';
import SavedAddress from './SavedAddress';
import CheckoutPageContext from '../../../../context/CheckoutPageContext';
import useLog from '../../../useLog/useLog';
import $document from '../../../../tools/document';
import SHIPPING_SPEED_UPDATE_MUTATION from '../../../../gql/shippingSpeed.gql';

export default function SavedAddressWrapper() {
  const [showSavedAddress, setShowSavedAddress] = useState(false);
  const [updateAddress, setUpdatedAddress] = useState();
  const [openModal, setOpenModal] = useState(false);
  const logger = useLog('checkout.updateAddressType');

  const {
    checkoutPageState, setCheckoutPageState, setIsUpdating,
  } = useContext(CheckoutPageContext);

  const setModalVisibility = (isVisible) => {
    setOpenModal(isVisible);
    $document.documentElement.setAttribute('data-scroll-lock', 'false');
  };
  const onSelectAddress = (address) => {
    setUpdatedAddress(address);
    setShowSavedAddress(true);
  };

  useEffect(() => {
    if (checkoutPageState?.addressBook?.addresses
       && checkoutPageState?.addressBook?.defaultShipping) {
      const selectedAddress = checkoutPageState?.addressBook?.addresses
        .find((item) => item.addressId
        === checkoutPageState?.addressBook?.defaultShipping);
      if (selectedAddress) {
        setUpdatedAddress(selectedAddress);
        setShowSavedAddress(true);
      }
    }
  }, [checkoutPageState?.addressBook]);

  const [updateAddressMutation] = useMutation(SHIPPING_SPEED_UPDATE_MUTATION, {
    onCompleted: (response) => {
      logger.debug('SHIPPING_SPEED_UPDATE_MUTATION_FROM_UPDATE_ADDRESS_RESULT', response);
      if (response.updateShippingSpeed) {
        setCheckoutPageState((currentState) => ({
          ...currentState, ...response.updateShippingSpeed,
        }));
      }
      onSelectAddress(response.updateShippingSpeed.shippingAddress);
      setIsUpdating(false);
    },
    onError: (err) => {
      setIsUpdating(false);
      logger.error(`ERR: ADDRESS_UPDATE_MUTATION: ${JSON.stringify(err)}`);
    },
  });

  const onAddNewAddress = () => {
    setShowSavedAddress(false);
    setUpdatedAddress(null);
    setModalVisibility(false);

    const event = new Event('clearShippingAddress');
    window.dispatchEvent(event);
  };
  const onUseThisAddress = (selectedAddress, isSelectedAddress) => {
    if (isSelectedAddress) {
      setModalVisibility(false);
      return;
    }
    setIsUpdating(true);
    setModalVisibility(false);
    updateAddressMutation({
      variables: {
        shippingAddress: {
          address1: selectedAddress.address1,
          address2: selectedAddress.address2,
          addressId: selectedAddress.addressId,
          addressType: selectedAddress.addressType,
          city: selectedAddress.city,
          country: selectedAddress.country,
          displayType: selectedAddress.displayType,
          firstName: selectedAddress.firstName,
          isBillingAllowed: selectedAddress.isBillingAllowed,
          isDefaultBilling: selectedAddress.isDefaultBilling,
          isDefaultShipping: selectedAddress.isDefaultShipping,
          isShippingAllowed: selectedAddress.isShippingAllowed,
          lastName: selectedAddress.lastName,
          orgName: selectedAddress.orgName,
          pickUpStoreId: selectedAddress.pickUpStoreId,
          poBox: selectedAddress.poBox,
          postalCode: selectedAddress.postalCode,
          state: selectedAddress.state,
          subType: selectedAddress.subType,
          title: selectedAddress.title,
        },
      },
    });
  };
  return (
    <>
      <SavedAddress
        textFor={checkoutPageState?.textFor}
        setModalVisibility={setModalVisibility}
        showSavedAddress={showSavedAddress}
        updateAddress={updateAddress}
        isSavedAddress={!!checkoutPageState?.addressBook?.addresses?.length}
      />
      {openModal
      && (
      <AddressSelectionModal
        addressData={checkoutPageState?.addressBook?.addresses}
        textFor={checkoutPageState?.textFor}
        shippingAddress={checkoutPageState?.shippingAddress}
        isOpen={openModal}
        onAddNewAddress={onAddNewAddress}
        setModalVisibility={setModalVisibility}
        onUseThisAddress={onUseThisAddress}
      />
      )}
    </>
  );
}
